import React, { useContext, useEffect, useState } from "react";
import "../AddNewLineage.css";
import { useMsal } from "@azure/msal-react";
import { protectedResources } from "../../../msalConfig";
import { MARTBUILDER_API } from "../../../constants/serverConfig";
import axios from "axios";
import { AuthContext } from "../../../AuthContext";

const DataBricks = ({
  connectionData,
  onSubmitFun,
  testConnectionSuccess,
  setTestConnectionSuccess,
  submissionSuccess,
}) => {
  const { dcerror, dctoken, getDatacraftToken } = useContext(AuthContext);
  const { instance } = useMsal();
  const account = instance.getActiveAccount();
  const request = {
    scopes: protectedResources.datacraft.scopes,
    account: account,
  };

  const [connectionCreds, setConnectionCreds] = useState({
    product: { id: "" },
    hostname: "",
    portName: "",
    userName: "",
    token: "",
    database: "",
  });

  const [productTableData, setProductTableData] = useState([]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setConnectionCreds((prevCreds) => ({
      ...prevCreds,
      [name]: value,
    }));
  };

  const handleSubmit = (isTestConnection) => {
    const formData = {
      ...connectionData,
      connectionCreds,
    };
    //below is going to return true if any input field is empty
    const isEmptyField = Object.values(connectionCreds).some(
      (value) => value.trim() === ""
    );

    if (isEmptyField) {
      alert("Please fill all input fields.");
      return;
    }
    if (onSubmitFun) {
      onSubmitFun(formData, isTestConnection);
    }
    // setTestConnectionSuccess(true);
  };

  const fetchProductTableData = async (dctoken) => {
    const ourRequest = axios.CancelToken.source();
    try {
      let response = await axios.get(`${MARTBUILDER_API}/product`, {
        headers: {
          Authorization: `Bearer ${dctoken}`,
          "Content-Type": "application/json",
        },
        CancelToken: ourRequest.token,
      });
      setProductTableData(response?.data);
    } catch (err) {
      if (axios.isCancel(err)) {
        return;
      } else {
        console.error(err);
      }
    }
    return () => {
      ourRequest.cancel();
    };
  };

  const callapiwithtoken = async (callback) => {
    (async () => await getDatacraftToken())();
    if (dctoken) {
      await callback(dctoken);
    }
    if (dcerror) {
      try {
        const rtoken = (await instance.acquireTokenRedirect(request))
          .accessToken;
        await callback(rtoken);
      } catch (error) {
        console.log(error);
      }
    }
  };

  useEffect(() => {
    callapiwithtoken(fetchProductTableData);
  }, [dctoken, dcerror]);

  return (
    <div>
      <div className="individualLRow">
        <div>
          <label htmlFor="product">Products Name</label>
          <br />
          <select
            id="product"
            name="product"
            onChange={handleChange}
            value={connectionCreds.product.id}
            style={{ fontSize: "12px" }}
          >
            {productTableData.map((product, index) => (
              <option key={index} value={product.id}>
                {product.name}
              </option>
            ))}
          </select>
          <p>Do not have a product registered? <span style={{ color: "#0a69b4", cursor: "pointer" }}>Register Now</span></p>
        </div>
      </div>
      <div className="individualLRow">
        <div className="inputHostName">
          <label htmlFor="hostname">ADB Name</label>
          <br />
          <input
            type="text"
            id="hostname"
            name="hostname"
            placeholder="Enter ADB Name"
            value={connectionCreds.hostname}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="individualLRow">
        <div>
          <label htmlFor="portName">Azure DataBricks Subscription</label>
          <br />
          <input
            type="text"
            id="portName"
            name="portName"
            placeholder="Enter ABD Subscription"
            onChange={handleChange}
            value={connectionCreds.portName}
          />
        </div>
        <div>
          <label htmlFor="portName">ADB Resource Group</label>
          <br />
          <input
            type="text"
            id="portName"
            name="portName"
            placeholder="Enter ADB Resource Group"
            onChange={handleChange}
            value={connectionCreds.portName}
          />
        </div>
      </div>
      <div className="individualLRow">
        <div className="inputWrapper">
          <label htmlFor="database">ADB URL</label>
          <br />
          <input
            type="text"
            id="database"
            name="database"
            placeholder="Enter ADB URL"
            onChange={handleChange}
            value={connectionCreds.database}
          />
        </div>
      </div>
      <div className="individualLRow">
        <div className="inputWrapper">
          <label htmlFor="ADBtoken">ADB Token</label>
          <br />
          <textarea
            style={{ height: "4rem", width: "100%" }}
            rows="4"
            type="text"
            id="ADBtoken"
            name="ADBToken"
            placeholder="Enter ADB Token"
            onChange={handleChange}
            value={connectionCreds.token}
          />
        </div>
      </div>

      <div
        className="individualLRow"
        style={{ marginTop: "20px", justifyContent: "flex-end" }}
      >
        {/* <button
          className="job-btn btn nar-wid"
          type="submit"
          // onSubmit={handleSubmit}
          onClick={() => handleSubmit(false)}
          // disabled={!testConnectionSuccess}
          // disabled={!testConnectionSuccess || submissionSuccess}
        >
          Submit
        </button> */}
        <button
          className="job-btn btn nar-wid"
          onClick={() => handleSubmit(true)}
        // disabled={!testConnectionSuccess}
        // disabled={!testConnectionSuccess || submissionSuccess}
        >
          Check Connection
        </button>
      </div>
    </div>
  );
};

export default DataBricks;
